import httpClient from "../utils/httpClient";

export const BlogData = async (requestParams) => {
    const response = await httpClient.post(`/Blog/blogs`, requestParams);
    return response.data;
};

export const BlogDetail = async (slug) => {
    const response = await httpClient.get(`/Blog/blogs/${slug}`);
    return response.data;

};

export const GetTrendyBlog = async () => {
    const response = await httpClient.post(`/Blog/blogs-trendy`, {});
    return response.data;

};
